type BottomNavIconProps = {
  className?: string;
};

export function HomeIcon({ className }: BottomNavIconProps) {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g opacity="0.4">
        <path
          d="M14.5884 3.72761C14.4273 3.58096 14.2173 3.49969 13.9995 3.49969C13.7816 3.49969 13.5716 3.58096 13.4105 3.72761L4.66047 11.9898C4.57042 12.0719 4.49852 12.1719 4.44936 12.2834C4.4002 12.3949 4.37487 12.5154 4.375 12.6373V22.7501C4.375 22.9822 4.46719 23.2047 4.63128 23.3688C4.79538 23.5329 5.01794 23.6251 5.25 23.6251H22.75C22.9821 23.6251 23.2046 23.5329 23.3687 23.3688C23.5328 23.2047 23.625 22.9822 23.625 22.7501V12.6373C23.625 12.5154 23.5995 12.3948 23.5501 12.2833C23.5008 12.1718 23.4287 12.0718 23.3384 11.9898L14.5884 3.72761Z"
          stroke="#111111"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export function HomeActiveIcon({ className }: BottomNavIconProps) {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M14.5884 3.72761C14.4273 3.58096 14.2173 3.49969 13.9995 3.49969C13.7816 3.49969 13.5716 3.58096 13.4105 3.72761L4.66047 11.9898C4.57042 12.0719 4.49852 12.1719 4.44936 12.2834C4.4002 12.3949 4.37487 12.5154 4.375 12.6373V22.7501C4.375 22.9822 4.46719 23.2047 4.63128 23.3688C4.79538 23.5329 5.01794 23.6251 5.25 23.6251H22.75C22.9821 23.6251 23.2046 23.5329 23.3687 23.3688C23.5328 23.2047 23.625 22.9822 23.625 22.7501V12.6373C23.625 12.5154 23.5995 12.3948 23.5501 12.2833C23.5008 12.1718 23.4287 12.0718 23.3384 11.9898L14.5884 3.72761Z"
        fill="#C41719"
        stroke="#C41719"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FavoritesIcon({ className }: BottomNavIconProps) {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g opacity="0.4">
        <path
          d="M19.3009 4.375C15.7506 4.375 14.0006 7.875 14.0006 7.875C14.0006 7.875 12.2506 4.375 8.70025 4.375C5.81493 4.375 3.53009 6.78891 3.50056 9.6693C3.4404 15.6483 8.24361 19.9002 13.5084 23.4735C13.6535 23.5723 13.825 23.6251 14.0006 23.6251C14.1761 23.6251 14.3476 23.5723 14.4927 23.4735C19.757 19.9002 24.5602 15.6483 24.5006 9.6693C24.471 6.78891 22.1862 4.375 19.3009 4.375Z"
          stroke="black"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export function FavoritesActiveIcon({ className }: BottomNavIconProps) {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M14.0006 24.5C13.6493 24.4996 13.3064 24.3934 13.0162 24.1954C8.71834 21.2778 6.85733 19.2773 5.83084 18.0266C3.64334 15.3606 2.59608 12.6235 2.62561 9.65945C2.66006 6.26281 5.38514 3.5 8.70029 3.5C11.1109 3.5 12.7805 4.85789 13.7529 5.98883C13.7837 6.02429 13.8217 6.05273 13.8645 6.07222C13.9072 6.09171 13.9536 6.10179 14.0006 6.10179C14.0476 6.10179 14.094 6.09171 14.1367 6.07222C14.1795 6.05273 14.2175 6.02429 14.2483 5.98883C15.2207 4.8568 16.8903 3.5 19.3009 3.5C22.6161 3.5 25.3412 6.26281 25.3756 9.66C25.4051 12.6246 24.3568 15.3617 22.1704 18.0272C21.1439 19.2779 19.2829 21.2784 14.985 24.1959C14.6948 24.3938 14.3518 24.4997 14.0006 24.5Z"
        fill="#C41719"
      />
    </svg>
  );
}

export function ChatIcon({ className }: BottomNavIconProps) {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g opacity="0.4">
        <path
          d="M23.5698 17.5328C23.5151 17.3359 23.6354 17.0625 23.7502 16.8656C23.7854 16.807 23.8237 16.7504 23.8651 16.6961C24.8474 15.2364 25.3729 13.5173 25.3745 11.7578C25.3909 6.71563 21.1362 2.625 15.8752 2.625C11.287 2.625 7.45884 5.74766 6.56196 9.89297C6.42779 10.5074 6.35995 11.1344 6.35962 11.7633C6.35962 16.8109 10.4502 21.0109 15.7112 21.0109C16.5479 21.0109 17.6745 20.7594 18.2924 20.5898C18.9104 20.4203 19.5229 20.1961 19.6815 20.1359C19.8441 20.0746 20.0163 20.0432 20.1901 20.043C20.3797 20.0422 20.5674 20.0794 20.7424 20.1523L23.8432 21.2516C23.9112 21.2803 23.9831 21.2988 24.0565 21.3063C24.1725 21.3063 24.2838 21.2602 24.3659 21.1781C24.4479 21.0961 24.494 20.9848 24.494 20.8688C24.4902 20.8187 24.481 20.7692 24.4666 20.7211L23.5698 17.5328Z"
          stroke="black"
          strokeWidth="1.75"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M3.63456 12.6875C2.9173 13.9761 2.57033 15.4379 2.632 16.9113C2.69367 18.3848 3.16158 19.8125 3.98402 21.0366C4.11035 21.2275 4.18144 21.3752 4.15956 21.4741C4.13769 21.5731 3.50714 24.8577 3.50714 24.8577C3.49198 24.9345 3.49773 25.014 3.5238 25.0879C3.54987 25.1618 3.5953 25.2273 3.65535 25.2777C3.73547 25.3415 3.83509 25.3759 3.93753 25.375C3.99227 25.3752 4.04646 25.364 4.09667 25.3422L7.17066 24.1391C7.38222 24.0557 7.61824 24.0596 7.82691 24.15C8.86269 24.5536 10.0078 24.8063 11.1535 24.8063C12.691 24.8079 14.2014 24.4024 15.5313 23.631"
          stroke="black"
          strokeWidth="1.75"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}

export function ChatActiveIcon({ className }: BottomNavIconProps) {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M3.30613 21.2828C3.30613 21.2867 3.30613 21.2938 3.30176 21.3036C3.3034 21.2971 3.30449 21.2899 3.30613 21.2828Z"
        fill="#C41719"
      />
      <path
        d="M24.0565 22.1813C23.8765 22.1774 23.6987 22.1403 23.5321 22.0719L20.4269 20.971L20.4039 20.9617C20.3362 20.9335 20.2635 20.9194 20.1901 20.9202C20.1225 20.9202 20.0554 20.9325 19.9921 20.9563C19.9167 20.9847 19.2369 21.2401 18.5238 21.4359C18.1371 21.542 16.7913 21.8881 15.7112 21.8881C12.9506 21.8881 10.3693 20.8272 8.44379 18.9006C7.50311 17.9657 6.75722 16.8535 6.24928 15.6283C5.74134 14.4032 5.48145 13.0895 5.48465 11.7633C5.48463 11.0722 5.55907 10.3832 5.70668 9.70813C6.18738 7.48672 7.46051 5.46602 9.29145 4.02063C11.1696 2.54737 13.4882 1.74772 15.8753 1.75C18.7305 1.75 21.3911 2.84376 23.3675 4.82235C25.2356 6.69649 26.2593 9.16071 26.2511 11.7606C26.2495 13.6924 25.6727 15.5801 24.5941 17.1828L24.5837 17.1981L24.5432 17.2528C24.5339 17.2654 24.5246 17.2774 24.5159 17.29L24.5077 17.3048C24.486 17.3418 24.4662 17.3799 24.4486 17.4191L25.3094 20.4783C25.3475 20.6045 25.3681 20.7353 25.3707 20.8671C25.3709 21.0398 25.337 21.2107 25.2711 21.3703C25.2051 21.5298 25.1083 21.6748 24.9862 21.7968C24.8642 21.9189 24.7192 22.0157 24.5597 22.0817C24.4001 22.1476 24.2292 22.1815 24.0565 22.1813Z"
        fill="#C41719"
      />
      <path
        d="M16.3992 23.2635C16.3427 23.1536 16.2632 23.0571 16.1661 22.9807C16.069 22.9043 15.9565 22.8496 15.8364 22.8205C15.5203 22.7368 15.1517 22.7511 14.8701 22.7303C12.2108 22.5454 9.70839 21.4041 7.82526 19.5174C6.15114 17.8526 5.06312 15.6891 4.72503 13.3525C4.64846 12.8198 4.64846 12.6875 4.64846 12.6875C4.64843 12.5097 4.59428 12.3362 4.49323 12.1901C4.39217 12.0439 4.24899 11.9319 4.08275 11.8691C3.9165 11.8063 3.73507 11.7956 3.56259 11.8384C3.39011 11.8812 3.23476 11.9756 3.11721 12.1089C3.11721 12.1089 2.68628 12.5781 2.48284 13.0489C1.91227 14.3636 1.66895 15.7969 1.77372 17.2262C1.87849 18.6554 2.32823 20.038 3.0844 21.2554C3.22659 21.4921 3.22659 21.6015 3.19487 21.8476C3.04557 22.6193 2.78417 23.9804 2.648 24.6864C2.60291 24.9154 2.61968 25.1522 2.69658 25.3726C2.77348 25.5929 2.90773 25.7887 3.0855 25.9399L3.11065 25.9612C3.34581 26.148 3.63722 26.2497 3.93753 26.25C4.10644 26.2501 4.27371 26.2168 4.42971 26.1521L7.35604 25.0228C7.4568 24.9845 7.5681 24.9845 7.66886 25.0228C8.82112 25.4515 10.0204 25.679 11.1568 25.679C12.5728 25.6804 13.9716 25.3693 15.2535 24.7679C15.5521 24.6279 16.0191 24.4759 16.2925 24.1598C16.396 24.0372 16.4613 23.8869 16.4802 23.7276C16.4992 23.5683 16.471 23.4069 16.3992 23.2635Z"
        fill="#C41719"
      />
    </svg>
  );
}

export function SellIcon({ className }: BottomNavIconProps) {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M14 2.65234C20.257 2.65234 25.3477 7.74299 25.3477 14C25.3477 20.257 20.257 25.3477 14 25.3477C7.74299 25.3477 2.65234 20.257 2.65234 14C2.65234 7.74299 7.74299 2.65234 14 2.65234ZM14 8.72266C13.7607 8.72266 13.5315 8.81808 13.3623 8.9873C13.1931 9.15653 13.0977 9.38568 13.0977 9.625V13.0977H9.625C9.38568 13.0977 9.15653 13.1931 8.9873 13.3623C8.81808 13.5315 8.72266 13.7607 8.72266 14C8.72266 14.2393 8.81808 14.4685 8.9873 14.6377C9.15653 14.8069 9.38568 14.9023 9.625 14.9023H13.0977V18.375C13.0977 18.6143 13.1931 18.8435 13.3623 19.0127C13.5315 19.1819 13.7607 19.2773 14 19.2773C14.2393 19.2773 14.4685 19.1819 14.6377 19.0127C14.8069 18.8435 14.9023 18.6143 14.9023 18.375V14.9023H18.375C18.6143 14.9023 18.8435 14.8069 19.0127 14.6377C19.1819 14.4685 19.2773 14.2393 19.2773 14C19.2773 13.7607 19.1819 13.5315 19.0127 13.3623C18.8435 13.1931 18.6143 13.0977 18.375 13.0977H14.9023V9.625C14.9023 9.38568 14.8069 9.15653 14.6377 8.9873C14.4685 8.81808 14.2393 8.72266 14 8.72266Z"
        fill="#C41719"
        stroke="#C41719"
        strokeWidth="0.0546875"
      />
    </svg>
  );
}

export function ProfileIcon({ className }: BottomNavIconProps) {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g opacity="0.4">
        <path
          d="M14.1597 2.62502C7.76231 2.53861 2.53965 7.76127 2.62606 14.1586C2.71137 20.294 7.70707 25.2897 13.8425 25.375C20.2409 25.4625 25.4625 20.2399 25.375 13.8425C25.2907 7.70604 20.295 2.71033 14.1597 2.62502ZM21.0732 20.5215C21.0515 20.5451 21.0248 20.5635 20.995 20.5756C20.9653 20.5877 20.9333 20.5931 20.9013 20.5914C20.8692 20.5898 20.8379 20.5811 20.8096 20.566C20.7813 20.5509 20.7567 20.5297 20.7375 20.504C20.2483 19.864 19.6493 19.3161 18.9683 18.8858C17.576 17.9922 15.8118 17.5 14.0011 17.5C12.1904 17.5 10.4261 17.9922 9.03379 18.8858C8.35286 19.3159 7.75383 19.8636 7.26465 20.5035C7.24543 20.5292 7.2208 20.5503 7.19249 20.5654C7.16419 20.5805 7.1329 20.5892 7.10086 20.5909C7.06882 20.5926 7.0368 20.5872 7.00708 20.5751C6.97735 20.563 6.95065 20.5445 6.92887 20.521C5.32416 18.7887 4.41516 16.5251 4.37606 14.1641C4.28692 8.84244 8.65371 4.38814 13.9775 4.37502C19.3014 4.36189 23.6261 8.68494 23.6261 14C23.6279 16.418 22.7161 18.7473 21.0732 20.5215Z"
          fill="black"
        />
        <path
          d="M13.9994 7.875C12.9209 7.875 11.9459 8.27914 11.253 9.01359C10.5601 9.74805 10.2139 10.7636 10.2921 11.8535C10.4507 14 12.1138 15.75 13.9994 15.75C15.885 15.75 17.5448 14 17.7067 11.8541C17.7876 10.7745 17.4442 9.76828 16.7398 9.02016C16.0442 8.28188 15.0707 7.875 13.9994 7.875Z"
          fill="black"
        />
      </g>
    </svg>
  );
}
